import React, { useState, useEffect } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import clsx from "clsx";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { usePanelStyles } from "../FormFields/panel";

const useStyles = makeStyles(() => ({
	// o formulário entra logo abaixo das tags no painel do contato
	form: {
		marginTop: 12,
	},
	actions: {
		display: "flex",
		justifyContent: "flex-end",
		flexWrap: "wrap",
		gap: 8,
		marginTop: 4,
	},
	btnWrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: "inherit",
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -10,
		marginLeft: -10,
	},
}));

const ContactSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, "Too Short!")
		.max(50, "Too Long!")
		.required("Required"),
	number: Yup.string().min(8, "Too Short!").max(50, "Too Long!"),
	email: Yup.string().email("Invalid email"),
});

export function ContactForm ({ initialContact, onSave, onCancel }) {
	const classes = useStyles();
	const p = usePanelStyles();

	const [contact, setContact] = useState(initialContact);

    useEffect(() => {
        setContact(initialContact);
    }, [initialContact]);

	const handleSaveContact = async values => {
		try {
			if (contact.id) {
				await api.put(`/contacts/${contact.id}`, values);
			} else {
				const { data } = await api.post("/contacts", values);
				if (onSave) {
					onSave(data);
				}
			}
			toast.success(i18n.t("contactModal.success"));
		} catch (err) {
			toastError(err);
		}
	};

    return (
        <Formik
            initialValues={contact}
            enableReinitialize={true}
            validationSchema={ContactSchema}
            onSubmit={(values, actions) => {
                setTimeout(() => {
                    handleSaveContact(values);
                    actions.setSubmitting(false);
                }, 400);
            }}
        >
            {({ values, errors, touched, isSubmitting }) => (
                <Form className={clsx(p.stack, p.labelsAbove, classes.form)}>
                    <Field
                        as={TextField}
                        label={i18n.t("contactModal.form.name")}
                        name="name"
                        autoFocus
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                    <Field
                        as={TextField}
                        label={i18n.t("contactModal.form.number")}
                        name="number"
                        error={touched.number && Boolean(errors.number)}
                        helperText={touched.number && errors.number}
                        placeholder="5513912344321"
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                    <Field
                        as={TextField}
                        label={i18n.t("contactModal.form.email")}
                        name="email"
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                        placeholder="email@exemplo.com"
                        fullWidth
                        size="small"
                        variant="outlined"
                    />
                    <div className={classes.actions}>
                        <Button onClick={onCancel} disabled={isSubmitting}>
                            {i18n.t("contactModal.buttons.cancel")}
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            disabled={isSubmitting}
                            variant="contained"
                            className={classes.btnWrapper}
                        >
                            {contact.id
                                ? `${i18n.t("contactModal.buttons.okEdit")}`
                                : `${i18n.t("contactModal.buttons.okAdd")}`}
                            {isSubmitting && (
                                <CircularProgress
                                    size={20}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
